// Port of api/fuel/app/classes/filter/package/games/game/prepare/status.php
export default {
	priority: 10,
	run: function(local) {
		var statuses = ['own', 'prevowned', 'fortrade', 'want', 'wanttoplay', 'wanttobuy', 'wishlist', 'preordered', 'hasparts', 'wantparts']
		local.status = { game: {}, user: {} }
		for (var i = 0; i < statuses.length; i++) {
			local.status.game[statuses[i]] = []
			local.status.user[statuses[i]] = 0
		}
		return local
	}
}
